import "react-toastify/dist/ReactToastify.css";
import AppRouter from "./router/Router";

function App() {
  return (
    <div className="App">
      <AppRouter/>
    </div>
  );
}

export default App;
